<template>
  <div class="dashboard-container">
    <div>
      <div class="title-area">
        <div class="title">
          {{ $t('page.dashboard.monitoringDashboard') }}
        </div>
        <div class="action">
          <ScpmReloadDatePicker
            ref="reloadPicker"
            isDashboard
            :refreshPlay="searchDateDashboard.isRefreshPlay"
            :defaultValue="searchDateDashboard.tab1value"
            :dateTime="searchDateDashboard"
            @refresh="onRefresh"
            @save="refresh"
          />
          <!-- refreshPlay 옵션은 기본값으로 reload기능 활성화 여부 -->
          <!-- this.$refs.reloadPicker.getCurrentDate() -->
          <!-- this.$refs.reloadPicker.setDate('7d'); //14d , 7d, 3d, 24h, 12h, 6h, 3h, 60m, 30m  -->
        </div>
      </div>
      <grid-layout
        style="margin: -20px"
        :layout="layout"
        :col-num="8"
        :row-height="134"
        :margin="[20, 20]"
      >
        <grid-item
          v-for="item in layout"
          :x="item.x"
          :y="item.y"
          :w="item.w"
          :h="item.h"
          :minW="item.chartAttr.minW"
          :maxW="item.chartAttr.maxW"
          :minH="item.chartAttr.minH"
          :maxH="item.chartAttr.maxH"
          :static="true"
          :i="item.i"
          drag-allow-from=".vue-draggable-handle"
          drag-ignore-from=".no-drag"
          :key="item.i"
          :class="
            item.chartAttr.widget.type === 'MonitoringStatusWidget'
              ? 'monitoring-status-widget'
              : ''
          "
        >
          <div class="box">
            <div class="box-header vue-draggable-handle"></div>
            <div class="content">
              <div style="width: 100%; height: 100%">
                <component
                  :excludeResources="excludeResources"
                  :is="item.chartAttr.widget.type"
                  :configItem="item"
                  :searchDate="searchDate"
                  @popup="onClickPopup"
                />
              </div>
            </div>
          </div>
        </grid-item>
      </grid-layout>
    </div>
    <MonTargetDetailPopup
      v-if="popup.monTargetDetail"
      isDashboard
      :params="monitoringModalParam"
      :refreshPlay="searchDateDashboard.isRefreshPlay"
      :defaultValue="searchDateDashboard.tab1value"
      :dateTime="searchDateDashboard"
      @close="togglePopup('monTargetDetail')"
    ></MonTargetDetailPopup>
  </div>
</template>

<script>
import i18nMixin from '@/mixins/i18n.mixin.js';
import { GridLayout, GridItem } from 'vue-grid-layout-v3'; //대시보드 라이브러리
import data from './dashboard.json'; //프로젝트 대시보드 기본 설정 파일.
import legoEventBus from '@/lego-component/utils/eventBus/eventBus';
// 프로젝트 대시보드에서 사용하는 위젯들.
import TitleBoxWidget from '../widget/components/TitleBoxWidget';
import EventStausWidget from '../widget/components/EventStausWidget';
import MonitoringStatusWidget from '../widget/components/MonitoringStatusWidget';
import PerfermanceTop5Widget from '../widget/components/PerfermanceTop5Widget';
import EventMapWidget from '../widget/components/EventMapWidget';
import EventHistoryWidget from '../widget/components/EventHistoryWidget';
import TimeSeriesGraphWidget from '../widget/components/TimeSeriesGraphWidget';
import StatusMetricWidget from '../widget/components/StatusMetricWidget';
import InstanceMapWidget from '../widget/components/InstanceMapWidget';
import ScpmReloadDatePicker from '@/components/scpm/components/scpmReloadDatePicker/scpmReloadDatePicker';
import MonTargetDetailPopup from '@/containers/popup/MonTargetDetailPopup.vue';
import { mapActions, mapState } from 'vuex';
import { GLOBAL_CDN } from '@/containers/utils/constant';

export default {
  components: {
    GridLayout,
    GridItem,
    TitleBoxWidget,
    EventStausWidget,
    MonitoringStatusWidget,
    PerfermanceTop5Widget,
    EventMapWidget,
    EventHistoryWidget,
    TimeSeriesGraphWidget,
    StatusMetricWidget,
    InstanceMapWidget,
    ScpmReloadDatePicker,
    MonTargetDetailPopup
  },
  mixins: [i18nMixin],
  async mounted() {
    this.setSearchDate(); // 조회기간 셋팅
    await this.getKeyTop5WidgetData();
    //시작시 dashboard.json 파일의 설정을 layout에 넣는다.
    this.layout = data.layout.map((d, i) => {
      d.i = i.toString();
      d.x = d.chartAttr.x;
      d.y = d.chartAttr.y;
      d.h = d.chartAttr.h;
      d.w = d.chartAttr.w;
      d.chartAttr.title = this.$t(d.chartAttr.title);
      if (
        d.chartAttr.widget.type === 'PerfermanceTop5Widget' &&
        this.dataTop5 &&
        this.dataTop5[i - 2] &&
        this.dataTop5[i - 2].metricKey
      ) {
        d.chartAttr.widget.options = {
          metricKey: this.dataTop5[i - 2].metricKey,
          resourceType: 'VM'
        };
        d.chartAttr.subtitle = this.dataTop5[i - 2].metricName;
      }
      return d;
    });
    legoEventBus.$on('open-modal', (isShow) => {
      this.$nextTick(() => {
        if (this.$refs.reloadPicker) {
          if (isShow) {
            this.$refs.reloadPicker.onPause();
          } else {
            this.$refs.reloadPicker.onStart();
          }
        }
      });
    });
  },
  beforeUnmount() {
    legoEventBus.$off('open-modal');
  },
  data() {
    return {
      now: '', // 우측 타이머 표기용
      timer: {}, // 타이머 인터벌 객체 저장
      isDropdownRefresh: false, // 리플래시 설정 드롭다운
      isRefreshPlay: false, // 자동 리플래시
      layout: [], // 위젯들 목록
      index: '0', // 레이아웃 내의 위젯의 인덱스
      loading: false, // 연속 새로고침 방지용 로딩
      monitoringModalParam: null, // 모니터링 상세 팝업 params
      popup: {
        // 팝업
        monTargetDetail: false // 모니터링 상세 팝업
      },
      searchDate: {}, // 위젯 검색 시간,
      dataTop5: null,
      excludeResources: [GLOBAL_CDN]
    };
  },
  watch: {
    layout: {
      // layout 변경시 위젯의 인덱스 계산
      handler() {
        this.index = Math.max(...this.layout.map((o) => Number(o.i) + 1), 0).toString();
      }
    }
  },
  computed: {
    ...mapState({
      searchDateDashboard: (state) => state.dashboardState.searchDateDashboard
    })
  },
  methods: {
    ...mapActions('dashboardState', ['setSearchDateDashboard']),
    dropdownMenu() {
      // 새로고침 관련 드롭다운 여닫기
      this.isDropdownRefresh = !this.isDropdownRefresh;
    },
    startLoading() {
      // 로딩시작
      this.$store.commit('setLoading', true);
    },
    endLoading() {
      // 1초후 로딩아이콘 해제
      window.setTimeout(() => {
        this.$store.commit('setLoading', false);
      }, 1000);
    },
    refresh(isCheck = false) {
      // 위젯 데이터 새로고침.
      this.setSearchDate();
      if (!this.loading && !isCheck) {
        this.layout = this.layout.map((d) => {
          d.chartAttr.title = this.$t(d.chartAttr.title);
          d.i = d.i + Number(this.index);
          return d;
        });
      }
      this.loading = true;
      window.setTimeout(() => {
        this.loading = false;
      }, 2000);
    },
    onRefresh() {
      this.refresh();
    },
    onClickPopup(data) {
      if (!data || !data.param) return;
      const listDataCheckAuth = [
        {
          productResourceId: data.param.productId,
          productName: data.param.productName
        }
      ];
      const payload = {
        productTypeCode: data.param.productTypeCode,
        params: {
          productId: data.param.productId
        },
        listDataCheckAuth
      };

      this.$store.dispatch('authStore/checkProductDetail', payload).then((res) => {
        if (res.type !== this.$const.AuthorizationResult.ALLOW) return;
        this.monitoringModalParam = data.param;
        this.togglePopup(data.id);
      });
    },
    // 팝업 닫기
    togglePopup(id) {
      this.popup[id] = !this.popup[id];
    },
    setSearchDate() {
      // 위젯 API 검색시간 설정
      this.searchDate = this.$refs.reloadPicker.getCurrentDate();
      this.searchDate.type = 'dashboard';
      this.setSearchDateDashboard(this.searchDate);
    },
    async getKeyTop5WidgetData() {
      let params = { productSq: '', objectType: '', size: 4 };

      await this.apiGetMainMetrics(params, 'VM').then((data) => {
        this.dataTop5 = data;
      });
    },
    async apiGetMainMetrics(params, productTypeCode) {
      return await this.$http.product.post('/v1/console/summary-metrics', params, true, false, {
        headers: { 'X-ResourceType': productTypeCode }
      });
    }
  }
};
</script>

<style lang="scss">
.monitoring-status-widget {
  z-index: 1;
}

.dashboard-container {
  .vue-grid-item:not(.vue-grid-placeholder) {
    background: white;
    border: 1px solid #e3e4e8;
    border-radius: 8px;
  }

  .vue-grid-item.vue-grid-placeholder {
    background: white;
    opacity: 1;
    border: 1px dashed #ccc;
    border-radius: 8px;
  }

  .vue-grid-item .box {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }

  .vue-grid-item .box .box-header {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    height: 60px;
    z-index: 1;
  }

  // .vue-grid-item:hover > .vue-resizable-handle {
  //     display: block !important;
  // }

  .vue-grid-item:hover .hoverActive {
    display: inline-block !important;
  }

  .vue-grid-item > .vue-resizable-handle {
    background-image: url(../../assets/img/dashboard/ic_resize.png);
    background-repeat: no-repeat;
    background-position: center;
    width: 16px;
    height: 16px;
    object-fit: contain;
    opacity: 0.4;
    // display: none;
  }

  .content {
    height: 100%;
    padding: 0px;
  }

  .vue-grid-item .minMax {
    font-size: 12px;
  }

  .vue-grid-item .add {
    cursor: pointer;
  }

  > div:nth-child(2) > div.simplebar-vertical {
    visibility: hidden !important;
  }
}
</style>
<style lang="scss" scoped>
.title-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  align-content: center;

  .title {
    line-height: 41px;
    font-size: 22px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.46;
    letter-spacing: normal;
    text-align: left;
    color: var(--dark);
  }

  .action {
    display: flex;
    align-items: center;

    & > button,
    & > div {
      margin: 0 !important;
    }
  }
}

.emptyWedget {
  width: 100%;
  height: calc(100vh - 140px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .noWidgetMessage {
    height: 54px;
    margin: 0 0 8px;
    font-family: $lego__font-family;
    font-size: 36px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: var(--dark);
  }

  .makeWidgetMessage {
    height: 27px;
    margin: 8px 20px 40px;
    font-family: $lego__font-family;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: #848396;
  }
}

::v-deep .lego-segment-wrapper {
  .lego-segment-button.lego-segment-button--medium {
    min-width: auto;
    width: 32px;
    height: 32px;
  }
}

.lego-dropdown-refresh {
  position: absolute;
  top: 33px;
  right: 0;
  width: 129px;
  border: solid 1px var(--blue-with-a-hint-of-purple);
  background-color: #fff;
  z-index: 100;

  & button {
    display: block;
    width: 100%;
    height: 34px;
    padding: 8px 10px;
    text-align: left;
    font-size: 13px;
    color: #1f2533;
    background-color: #fff;
    border: 0;
    outline: none;
    cursor: pointer;

    &.active,
    &:hover {
      color: rgb(54, 79, 199);
      background-color: rgba(174, 184, 233, 0.12);
    }
  }
}

::v-deep .lego-segment-button {
  path: {
    fill: #1f2533;
    opacity: 0.6;
  }
}

::v-deep .lego-segment-button--checked {
  path {
    fill: #364fc7;
  }
}
</style>
